import type { Comment } from "@/api/http/schemas/commentsSchema";

const renderCommentAsPlainText = (comment: Comment) => {
  const content = comment.content.content;
  const textContent = content
    .filter((content) => content.type === "text")
    .map((content) => content.text);
  const asText = textContent.join(" ");

  return asText;
};

export { renderCommentAsPlainText };
